var React = require('react');

var PropTypes = require('prop-types');

var INPUT_HEIGHT_OPTIONS = ['small'];
var INPUT_PROP_TYPES = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  defaultText: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  prefix: PropTypes.string,
  blurOnEnterKey: PropTypes.bool,
  blurOnEscKey: PropTypes.bool,
  dir: PropTypes.string,
  defaultInputClass: PropTypes.string,
  innerInputClass: PropTypes.string,
  initialSelectionStart: PropTypes.number,
  initialSelectionEnd: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  shouldBlockOuterScroll: PropTypes.bool,
  focus: PropTypes.bool,
  onClick: PropTypes.func,
  focusOnPrefixClick: PropTypes.bool,
  showInfoTooltip: PropTypes.bool,
  infoTooltipProps: PropTypes.object,
  isReadOnly: PropTypes.bool,
  autoSelect: PropTypes.bool,
  selectOnFocus: PropTypes.bool,
  revertValueOnCancel: PropTypes.bool,
  successValue: PropTypes.string,
  preventBlur: PropTypes.bool,
  inputTextSuffix: PropTypes.string,
  selectionActionCounter: PropTypes.number,
  inputHeight: PropTypes.oneOf(INPUT_HEIGHT_OPTIONS)
};
var validatorType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]);
var syncValidatorType = PropTypes.oneOfType([validatorType, PropTypes.arrayOf(PropTypes.shape({
  validator: PropTypes.func.isRequired,
  invalidMessage: PropTypes.string.isRequired
}))]);
var VALIDATED_PROP_TYPES = {
  isValid: PropTypes.bool,
  validateInitialValue: PropTypes.bool,
  validateOnBlur: PropTypes.bool,
  tooltipOnInitialValidation: PropTypes.bool,
  tooltipInteractive: PropTypes.bool,
  validateOnValuePropChange: PropTypes.bool,
  allowInvalidChange: PropTypes.bool,
  onValidationStatus: PropTypes.func,
  validator: syncValidatorType,
  asyncValidator: validatorType,
  invalidMessage: PropTypes.string,
  syncDelay: PropTypes.number,
  asyncDelay: PropTypes.number,
  cancelValidationOnUnmount: PropTypes.bool,
  closeTooltipOnClickOutside: PropTypes.bool,
  hideSuccessIndication: PropTypes.bool
};

var inputElement = function inputElement() {
  return React.createElement('div');
};

inputElement.propTypes = INPUT_PROP_TYPES;

var validatedElement = function validatedElement() {
  return React.createElement('div');
};

validatedElement.propTypes = VALIDATED_PROP_TYPES;
module.exports = {
  INPUT_PROP_TYPES: INPUT_PROP_TYPES,
  INPUT_HEIGHT_OPTIONS: INPUT_HEIGHT_OPTIONS,
  VALIDATED_PROP_TYPES: VALIDATED_PROP_TYPES
};